/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import './LabelIntro.scss';
// import arrow from '../../assets/arrow-rt.svg';
import download from '../../assets/download.svg';
import check from '../../assets/check.svg';
import info from '../../assets/info.svg';
import { View as viewContext } from '@twintag/twintag-core';
import { View } from '@esoptra/zaza-sdk';
import { Loader } from '@/components/blocks';
import history from '../../assets/history.svg';
import PreviewModal from '../PreviewModal/PreviewModal';
import { Tooltip } from '@mui/material';
import StatusModal from './StatusModal';

const LabelIntro = ({ metadata, translation, company,
    // showDiscoverBtn 
}: any) => {
    const [labelURL, setLabelURL] = React.useState('');
    const [showStatusModal, setShowStatusModal] = React.useState(false);

    const [showLoader, setShowLoader] = React.useState(false);
    const [validationStatementURL, setValidationStatementURL] =
        React.useState<any>('');
    const [managementCommitmentLetterURL, setManagementCommitmentLetterURL] =
        React.useState<any>('');
    const [exemptionLetterURL, setExemptionLetterURL] = React.useState<any>('');

    React.useEffect(() => {
        if (metadata?.label)
            onSetLabelURL(metadata.$qid, metadata.label.FileQid);
    }, [metadata]);

    const onSetLabelURL = async (qid: string, fileQid: string) => {
        const file = await getFileURL(qid, fileQid);
        setLabelURL(file.fileURL);
    };

    // const scrollElementIntoView = (
    //     element: HTMLElement,
    //     behavior?: 'smooth' | 'auto'
    // ) => {
    //     let scrollTop = window.pageYOffset || element.scrollTop;

    //     const finalOffset = element.getBoundingClientRect().top + scrollTop;

    //     window.scrollTo({
    //         top: finalOffset,
    //         behavior: behavior || 'auto',
    //     });
    // };

    // const scrollToDiscoverLabels = () => {
    //     scrollElementIntoView(
    //         document.querySelector('#discover') as HTMLElement,
    //         'smooth'
    //     );
    // };

    const onPreviewExemptionLetter = async () => {
        setShowLoader(true);
        const file = await getFileURL(
            metadata.$qid,
            metadata.exemptionLetter.FileQid
        );
        setExemptionLetterURL(file.fileURL);
        setShowLoader(false);
    };

    const onPreviewValidationStatement = async () => {
        setShowLoader(true);
        const file = await getFileURL(
            metadata.$qid,
            metadata.vincotteValidationStatement.FileQid
        );
        setValidationStatementURL(file.fileURL);
        setShowLoader(false);
    };

    const onPreviewManagementCommitmentLetter = async () => {
        setShowLoader(true);
        const file = await getFileURL(
            metadata.$qid,
            metadata.managementCommitmentLetter.FileQid
        );
        setManagementCommitmentLetterURL(file.fileURL);
        setShowLoader(false);
    };

    const goto = (url: string) => {
        if (url) window.open(url, '_blank');
    };

    const getFileURL = async (qid: string, fileQid: string) => {
        const view = new View(viewContext.getId());
        const obj = await view.object('metadata');
        const file: any = await obj.getFile(qid, fileQid);
        return file;
    };

    return (
        <>
            {showLoader && <Loader />}

            {showStatusModal && (
                <StatusModal
                    title={translation('landing.validatedStatusText')}
                    content={translation('landing.validatedStatusHelpText')}
                    closeBtnText={translation('landing.closeButton')}
                    onClose={setShowStatusModal}
                />
            )}

            {validationStatementURL && (
                <PreviewModal
                    url={validationStatementURL}
                    name={metadata.vincotteValidationStatement.Name}
                    onClose={() => setValidationStatementURL('')}
                    downloadText={translation('common.downloadBtn')}
                />
            )}
            {managementCommitmentLetterURL && (
                <PreviewModal
                    url={managementCommitmentLetterURL}
                    name={metadata.managementCommitmentLetter.Name}
                    onClose={() => setManagementCommitmentLetterURL('')}
                    downloadText={translation('common.downloadBtn')}
                />
            )}
            {exemptionLetterURL && (
                <PreviewModal
                    url={exemptionLetterURL}
                    name={metadata.exemptionLetter.Name}
                    onClose={() => setExemptionLetterURL('')}
                    downloadText={translation('common.downloadBtn')}
                />
            )}
            <div className='label-container'>
                {labelURL && (
                    <div className='label-img'>
                        <img src={labelURL} alt='' />
                    </div>
                )}
                <div>
                    <div className='card'>
                        {company && (
                            <>
                                <div className='flexDis'>
                                    <img
                                        src={company?.logo?.URL}
                                        className='logo'
                                    />
                                    <div>
                                        <h1
                                            className='green-text cursor-pointer'
                                            onClick={() =>
                                                goto(company.website)
                                            }
                                        >
                                            {company.name}
                                        </h1>
                                    </div>
                                </div>
                            </>
                        )}
                        <div
                            className={
                                'info-wrapper m-t-1 ' +
                                ((metadata.level ||
                                    metadata.type ||
                                    metadata.status) &&
                                    (metadata.vincotteValidationStatement ||
                                        metadata.managementCommitmentLetter)
                                    ? 'm-b-1'
                                    : '')
                            }
                        >
                            {metadata.level &&
                                metadata?.type?.toLowerCase() !== 'activity' ? (
                                <div className='flex-container'>
                                    <h5 className='grey-text flex-1  op-4'>
                                        {translation('landing.levelLabel')}
                                    </h5>
                                    <h2
                                        className={
                                            metadata.level?.toLowerCase()?.trim() +
                                            '-text flex-1 '
                                        }
                                    >
                                        {metadata.level}
                                    </h2>
                                </div>
                            ) : null}
                            {metadata.type && (
                                <div className='flex-container'>
                                    <h5 className='grey-text flex-1  op-4'>
                                        {translation('landing.typeLabel')}
                                    </h5>
                                    <h2 className='grey-text flex-1 '>
                                        {metadata.type}
                                    </h2>
                                </div>
                            )}
                            {metadata.perimeter && (
                                <div className='flex-container'>
                                    <h5 className='grey-text flex-1  op-4'>
                                        {translation('landing.perimeterLabel')}
                                    </h5>
                                    <h2 className='grey-text flex-1 '>
                                        {metadata.perimeter}
                                    </h2>
                                </div>
                            )}
                            <div className='flex-container'>
                                <h5 className='grey-text flex-1  op-4'>
                                    {translation('landing.labelStatus')}
                                </h5>
                                <h2
                                    className={
                                        (metadata?.expired
                                            ? 'red-text'
                                            : metadata?.validated
                                                ? 'green-lt-text'
                                                : 'grey-text') +
                                        ' flex-1  flex-container'
                                    }
                                >
                                    {metadata?.expired ? (
                                        <>
                                            {translation(
                                                'landing.expiredStatusText'
                                            )}{' '}
                                        </>
                                    ) : metadata?.validated ? (
                                        <span
                                            onClick={() =>
                                                setShowStatusModal(true)
                                            }
                                            className='cursor-pointer'
                                        >
                                            {translation(
                                                'landing.validatedStatusText'
                                            )}{' '}
                                            &nbsp;
                                            <img src={check} alt='' />
                                            <img className='info-icon' src={info} alt='' height={20} />
                                        </span>
                                    ) : (
                                        <>
                                            <Tooltip
                                                title='CO2logic approved this label, Vinçotte is currently busy with the audit in order to validate it.'
                                                enterTouchDelay={0}
                                            >
                                                <div className='pointer'>
                                                    {translation(
                                                        'landing.pendingStatusText'
                                                    )}
                                                </div>
                                            </Tooltip>
                                            &nbsp;
                                            <Tooltip
                                                title='CO2logic approved this label, Vinçotte is currently busy with the audit in order to validate it.'
                                                enterTouchDelay={0}
                                            >
                                                <img
                                                    src={history}
                                                    alt=''
                                                    height={21}
                                                    className='pointer'
                                                />
                                            </Tooltip>
                                        </>
                                    )}
                                </h2>
                            </div>
                        </div>
                        {metadata?.exemptionLetter ? (
                            <button
                                className='primary'
                                onClick={onPreviewExemptionLetter}
                            >
                                Exemption Letter
                                <img src={download} alt='' />
                            </button>
                        ) : null}

                        {metadata?.vincotteValidationStatement &&
                            metadata?.validated ? (
                            <button
                                className='secondary'
                                onClick={onPreviewValidationStatement}
                            >
                                {translation('landing.validationStatementBtn')}
                                <img src={download} alt='' />
                            </button>
                        ) : null}

                        {metadata?.managementCommitmentLetter && (
                            <button
                                className='primary'
                                onClick={onPreviewManagementCommitmentLetter}
                            >
                                {translation(
                                    'landing.managementCommitmentLetter'
                                )}
                                <img src={download} alt='' />
                            </button>
                        )}
                        {/* {showDiscoverBtn && (
                            <button onClick={scrollToDiscoverLabels}>
                                {translation('landing.discoverOtherLabelsBtn')}
                                <img src={arrow} alt='' />
                            </button>
                        )} */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default LabelIntro;
